import PreventiveAppointmentList from "./PreventiveAppointmentList";
const BreachedPreventiveAppointmentList = () => {
  return (
    <div>
      <PreventiveAppointmentList isBreached={true} />
    </div>
  );
};

export default BreachedPreventiveAppointmentList;
